import { EntitiesConfiguration } from "@bds/next-sdr";
import { Azienda } from "./entities/Azienda";

export const LOCALHOST_PORT = "10010";

export enum TipiTabellaAlbi {
  ALBO = "ALBO",
  ALBO_TUTTE = "ALBO_TUTTE",
  PROVVEDIMENTI = "PROVVEDIMENTI",
  PROFILO_COMMITTENTE = "PROFILO_COMMITTENTE",
  REGISTRO_ACCESSI = "REGISTRO_ACCESSI",
}

export enum SpecificheTabellaAlbi {
  DIRIGENTI = "DIRIGENTI",
  POLITICI = "POLITICI",
  ATTI = "ATTI",
  PROCEDURE = "PROCEDURE",
  ESITI = "ESITI",
  DETERMINE = "DETERMINE",
  ATTI_DI_ESECUZIONE = "ATTI_DI_ESECUZIONE",
  LEGGE190 = "LEGGE190",
}

export enum AmbientiTabellaAlbi {
  PROD,
  TEST,
  SVILUPPO,
  LOCALHOST,
}

export interface Albo {
  tipo: TipiTabellaAlbi;
  specifica: SpecificheTabellaAlbi;
  ambiente: AmbientiTabellaAlbi;
  azienda: string;
}

export interface EntitiesStructure {
  [key: string]: EntitiesConfiguration;
}

export const ENTITIES_STRUCTURE: EntitiesStructure = {
  albi: {
    pubblicazioni: {
      path: "pubblicazione",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "pubblicazione",
      keyName: "id",
    },
    pubblicazionealboattiva: {
      path: "pubblicazionealboattiva",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "pubblicazionealboattiva",
      keyName: "id",
    },
    pubblicazionealbotutte: {
      path: "pubblicazionealbotutte",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "pubblicazionealbotutte",
      keyName: "id",
    },
    pubblicazioneregistroaccessiattiva: {
      path: "pubblicazioneregistroaccessiattiva",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "pubblicazioneregistroaccessiattiva",
      keyName: "id",
    },
    pubblicazionecommittenteattiva: {
      path: "pubblicazionecommittenteattiva",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "pubblicazionecommittenteattiva",
      keyName: "id",
    },
    provvedimentoattivo: {
      path: "provvedimentoattivo",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "provvedimentoattivo",
      keyName: "id",
    },
    azienda: {
      path: "azienda",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "azienda",
      keyName: "id",
    },
    parametroaziende: {
      path: "parametroaziende",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "parametroaziende",
      keyName: "id",
    },
    allegato: {
      path: "allegato",
      standardProjections: {},
      customProjections: {},
      collectionResourceRel: "allegato",
      keyName: "id",
    },
  },
};

export function getInternautaUrl(): string {
  let port;
  const wl = window.location;
  if (wl.hostname === "localhost") {
    port = LOCALHOST_PORT;
  } else {
    port = wl.port;
  }

  const out: string = wl.protocol + "//" + wl.hostname + ":" + port + "/albi-api/resources";

  // console.log(out);

  return out;
}
